exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-4e287246] .filter-froms .el-input__inner{width:1.86667rem}.text-cut_two[data-v-4e287246]{-webkit-line-clamp:4}", ""]);

// exports
